export default {
  recap: {
    language: 'Langues',
    loadingRecap: 'Téléchargement du récapitulatif…',
    product: 'Produit(s)',
    noPictureBrowser:
      "Vous ne pouvez pas prendre de photos à partir de la version navigateur de l'appli.",
    differentImageReasonCode: 'Veuillez choisir un autre code de motif pour la photo.',
    validationError:
      'Vous avez donné une réponse invalide à une question. Veuillez revoir les questions ci-dessous.',
    page: {
      page: 'Page',
      back: 'Retour',
      next: 'Page Suivante',
      finish: 'Finir',
    },
    partialSaveError:
      "Impossible d'enregistrer l'enquête incomplète. Si vous changez de tâche, puis revenez à celle-ci, vos réponses risquent de ne pas être enregistrées.",
  },
  payPeriod: {
    title: 'Période de paie en cours',
    cycle: 'Cycle',
    delayNote:
      'Veuillez noter qu’il y aura un délai dans la mise à jour de la page de la période de paie en cours pour les totaux',
    toBePaidHours: 'Heures à rémunérer',
    toBePaid: 'à rémunérer',
    expenses: 'Dépenses',
    time: 'Heures',
    orderItems: 'Commande d’articles',
    edits: 'Modifications',
    lastUpdated: 'Dernière mise à jour',
    accepted: 'Accepté',
    declined: 'Diminué',
    fixBy: 'Fix by ',
    incomplete: 'Incomplète',
    processing: 'Traitement',
  },
  timeline: {
    welcome: 'Bienvenue',
    pleaseSync: 'Veuillez synchroniser pour commencer à utiliser FHS Next Gen',
    initializing: 'Initialisation du FHS Next Gen',
    expenses: 'Dépenses',
    totalTime: 'Total des heures',
    current: 'En cours',
    miles: 'Milles',
    km: 'Kilomètres',
  },
  timecard: {
    denied: 'Vous avez une feuille de temps refusée.',
    approved: 'Cette fiche de temps a été approuvée.',
    processing: 'Cette fiche de temps est bloquée. En cours de traitement par votre gestionnaire.',
    processingOpen:
      'Cette fiche de temps est bloquée. En cours de traitement par votre gestionnaire. Pour ajouter des activités ou des dépenses, ouvrez à nouveau et soumettez la fiche.',
    syncing: 'Cette fiche de temps sera synchronisée.',
    declined: 'Des problèmes qui doivent être corrigés ont éte relévés sur cette fiche. ',
    elapsed:
      'Cette période de paie est échue. Veuillez synchroniser en fin de journée, puis contactez votre gestionnaire.',
    incomplete:
      "Cette fiche de temps est incomplète. Veuillez transmettre pour poursuivre l'utilisation de FHS NextGen.",
    editing: 'Vous modifiez actuellement une fiche de temps pour',
    doneFixing: 'Terminer',
    openTimecard: 'Ouvrir',
  },
  activities: {
    storeTask: "Tâche d'un magasin",
    travel: 'Déplacement',
    store: 'Visite en magasin',
    communication: 'Communication',
    material: 'Coordination du matériel',
    coupon: 'Retours des bons',
    break: 'Pause',
    training: 'Formation',
    team: 'Activité en équipe',
    other: 'Divers/Autres',
  },
  sideNav: {
    messages: 'Messages',
    expenses: 'Dépenses',
    activities: 'Activités',
    profile: 'Profil',
    settings: 'Paramètres',
    support: 'Assistance',
    signOut: 'Fin de session',
    currentPayPeriod: 'Période de paie en cours',
  },
  settings: {
    profileOptions: 'Options de profil',
  },
  form: {
    maintenance: 'Maintenance',
    maintenanceMessage: "FHS fait l'objet d'une brève maintenance. Veuillez réessayer sous peu.",
    job: 'ID du projet',
    wave: 'Vague',
    downloadPDFs: 'Télécharger des PDF',
    deletePDFs: 'Supprimer des PDF',
    deleteFilter: 'Supprimer le filtre',
    updateFilter: 'Mettre à jour le filtre',
    logoutRmActivities:
      "Une connexion sous un utilisateur différent supprimera toutes les activités qui n'ont pas été synchronisées.",
    logoutTimecardNotSub:
      "Vous travaillez sur une feuille de temps qui n'a pas encore été soumise. ",
    logoutWipeActivities: 'La déconnexion effacera vos activités pour la journée. ',
    logoutDestructive:
      "Il s'agit d'une action destructrice qui ne pourra pas être annulée. Êtes-vous sûr?",
    warning: 'Avertissement',
    logout: 'Logout',
    agree: "Je suis d'accord",
    disagree: "Je ne suis pas d'accord",
    updateStatus: 'Mise à jour du statut',
    bulkUpdateRai: 'Mise à jour RAI en bloc',
    bulkUpdateRaiNote:
      'Les mises à jour en bloc ne concernent que les tâches avec une date de départ en cours, qui ne sont pas des tâches de mise en marché.',
    bulkUpdateRaiFilter:
      'Vous pouvez utiliser un filtre pour voir les tâches qui sont accessibles à une mise à jour en bloc.',
    bulkUpdateRaiNotApplicable:
      'Le code RAI doit être applicable à toutes les tâches sélectionnées.',
    wipeData: "Effacer les données de l'appareil",
    promptStoreVisit:
      "L'activité Visite en magasin ne peut être ouverte que sur la page Visualiser le travail en magasin.",
    promptDeleteActivityHeader: 'Activité supprimée',
    promptDeleteActivity: 'Êtes-vous sûr(e) de vouloir supprimer cette activité?',
    endCurrentMessage: "Terminez l'activité en cours avant d'en commencer une autre",
    newMessage: 'Nouveau message',
    to: 'Destinataire',
    subject: 'Objet',
    message: 'Messages',
    sendMessage: 'Envoi du message',
    adjust: 'Réviser',
    add: 'Ajouter',
    description: 'Description',
    amount: 'Montant',
    date: 'Date',
    total: 'Total',
    sendExpenseReport: 'Envoyer le rapport des dépenses',
    addToOrder: 'Ajouter à la commande',
    quantity: 'Quantité',
    newQuantity: 'Nouvelle quantité',
    reason: 'Raison',
    comment: 'Commentaire(s)',
    startStore: 'Commencer la visite en magasin',
    resumeStore: 'Reprendre la visite en magasin',
    endStore: 'Terminer la visite en magasin',
    endStoreActiveTask: 'Veuillez terminer la tâche active avant de clore cette visite en magasin.',
    activityType: "Type d'activité",
    startTime: 'Heure de départ',
    endTime: 'Heure de fin',
    duration: 'Durée',
    startOdo: "Lancer l'odomètre",
    endOdo: "Fermer l'odomètre",
    distance: 'Distance',
    location: 'Lieu',
    destination: 'Destination',
    travelingMessage: 'Vous être maintenant en déplacement.',
    close: 'Fermer',
    save: 'Enregistrer',
    start: 'Commencer',
    continue: 'Continuer',
    cancel: 'Annuler',
    departingFrom: 'Départ de',
    departingStore: 'Magasin de départ',
    destinationStore: 'Destination (magasin)',
    startTravel: 'Lancer le déplacement',
    stopTravel: 'Terminer le déplacement',
    saveTravel: 'Enregistrer le déplacement',
    addActivity: 'Ajouter une activité',
    saveNewActivity: 'Enregistrer la nouvelle activité',
    stopSave: 'Arrêter et enregistrer',
    delete: 'Supprimer',
    type: 'Type',
    requiredGeneric: 'Champ requis',
    notBeforeNow: "Ne peut être programmé avant l'heure actuelle",
    startOverlapEnd: "L'heure de début ne peut chevaucher l'heure de fin.",
    endOverlapStart: "L'heure de fin ne peut chevaucher l'heure de début.",
    betweenActivities: 'Ne peut se situer entre des activités existantes',
    overlapActivities: 'Ne peut chevaucher des activités existantes',
    odometerSmaller: "La lecture doit être inférieure à l'odomètre en fin de journée.",
    odometerLarger: "La lecture doit être inférieure à l'odomètre en début de journée.",
    childrenSum: 'La durée totale des tâches ne peut pas être supérieure à la visite en magasin',
    endOfDay: 'Fin de la journée',
    endOfDayInfo: 'Vous êtes sur le point de conclure votre journée si vous poursuivez.',
    travelOverride: 'Exception du kilométrage 30/30? (autorisation du GS nécessaire)',
    travelOverrideCan: 'Exception du kilométrage 20/20? (autorisation du GS nécessaire)',
    payrollCertLang: "Langue d'affichage de la certification de la paie",
    endDay: 'Fin de la journée',
    recapPreview: 'Visualiser le récapitulatif',
    update: 'Actualiser',
    updateLastTask: 'Mettre à jour la dernière tâche',
    options: {
      core: 'RGL',
      merchandising: 'Marchandisage',
      transfer: 'Transfert',
      atStore: 'En magasin',
      unscheduledTasks: 'Tâches non planifiées',
      minimumHourRequirement: "Exigence minimale d'heures",
      cartFraming: 'Cadre de chariot',
      home: 'Domicile',
      warehouse: 'Entrepôt',
      store: 'Magasin',
      other: 'Autre',
      break: 'Pause',
      paidBreak: 'Pause avec solde',
      virtualOnline: 'Virtuel et en ligne',
      virtualTrainer: 'Activités virtuelles du formateur',
      retailMerchCoach: 'Coach de mise en marché au détail',
      operationSupport: 'Soutien des opérations',
      recruitingDuties: 'Missions de recrutement',
      instore: 'EN MAGASIN',
      cart: 'CHARIOTS',
      merch: 'MISE EN MARCHÉ',
    },
    messages: {
      message: 'Message',
      reply: 'Répondre',
      subject: 'Objet',
      departDestNotSame: 'Le départ/La destination ne peuvent être identiques.',
      storesNotSame: "Les magasins de départ/d'arrivée ne peuvent être identiques.",
      storesNotDefined: 'Le magasin doit être défini.',
      locationNotNull: 'Un lieu doit être choisi.',
      noResults: 'Aucun résultat',
      fieldNotNull: 'Ce champ ne peut être vide.',
      aboveZero: 'La saisie doit être supérieure à zéro',
      notNegative: 'La saisie ne peut être négative.',
      noDecimal: 'La saisie doit être un nombre entier.',
    },
    orderReasons: {
      neverReceivedOriginal: 'Original jamais reçu',
      receivedPartialShipment: 'Livraison partiellement reçue',
      receivedIncorrectMaterials: 'Erreur de réception du matériel',
      materialsReceivedDamaged: 'Matériel reçu endommagé',
      others: 'Autre',
      lost: 'Perdu',
      damaged: 'Endommagé',
      found: 'Trouvé',
      transfer: 'Transfert de rep à rep',
      cycleCount: 'Décompte de cycle',
      recoveredAtStore: 'Retrouvé en magasin',
    },
  },
  language: 'Langue',
  menu: {
    home: 'Accueil',
    tasks: 'Tâches',
    stores: 'Magasins',
    timeTracking: 'Suivi du Temps',
    inventory: 'Inventaire',
    preferences: 'Préférences',
    messaging: 'Messagerie',
    timeline: 'Calendrier des activités',
    lastSynced: 'Dernière synchronisation',
  },
  login: {
    welcome: 'Bienvenue à FHS',
    username: "Nom d'utilisateur",
    password: 'Mot de passe',
    login: 'Ouverture de session',
    errorInvalid: "Nom d'utilisateur ou mot de passe invalide",
    errorCommunication: 'Impossible de se connecter. Essayez plus tard.',
    expired: 'Votre demande a expiré. Veuillez réessayer dans quelques instants.',
    connection:
      "Une erreur s'est produite lors de la connexion à Internet. Veuillez réessayer dans quelques instants.",
    loggingIn: 'Se connecter...',
  },
  data: {
    allData: 'Toutes les données',
    item: 'Élément(s)',
    noData: "Il n'y a aucune donnée à afficher",
    noGroupData: "Il n'y a aucune donnée dans ce groupe à afficher",
    filtering: {
      filter: 'Filtre',
      addFilter: 'Ajouter un filtre',
      applyFilter: 'Activer le filtre',
      groupBy: 'Grouper par',
      sortBy: 'Trier par',
      search: 'Chercher',
      addCondition: 'Ajout une condition',
      field: 'Champ',
      operator: 'Opérateur',
      date: 'Date',
      value: 'Valeur',
      operators: {
        comparison: {
          equals: 'égal à',
          notEqual: "n'est pas égal à",
          greaterThan: 'plus grand que',
          lessThan: 'moins que',
          is: 'est',
          isNot: "n'est pas",
          isEmpty: 'est vide',
          onDate: 'à la date',
          onOrBefore: 'au plus tard le',
          onOrAfter: 'à compter du',
          beforeDate: 'avant le',
          afterDate: 'après le',
          isTrue: 'est vrai',
          isFalse: "c'est faux",
          isAnyOf: "est l'un des élémens suivants",
          isNotAnyOf: "n'est pas l'un des éléments suivants",
        },
        date: {
          exactDate: 'date exacte',
          today: "aujourd'hui",
          tomorrow: 'demain',
          yesterday: 'hier',
          oneWeekPast: 'il y a une semaine',
          oneWeekFuture: 'dans une semaine',
          oneMonthPast: 'il y a un mois',
          oneMonthFuture: 'dans un mois',
        },
      },
    },
  },
  media: {
    takePhoto: 'Prendre une Photo',
    clearPhotos: 'Supprimer les photos',
    savingPhoto: 'Enregistrement de la photo...',
    abortUpload: 'Interrompre le téléchargement',
    error: "Une erreur s'est produite lors de la capture de la photo, veuillez réessayer.",
  },
  storeItems: {
    suggestEdit: 'Suggérer une modification',
    details: 'Détails',
    survey: 'Données de premier niveau',
    carts: 'Chariots',
    pedestals: 'Socles',
    small_carts_1sd: 'Unité petit format 1 côté',
    small_carts_std: 'Unité petit format 2 côtés',
    small_carts_thin: 'Unité mince petit format',
    large_carts_1sd: 'Unité grand format 1 côté',
    large_carts_std: 'Unité grand format 2 côtés',
    liberty_pedestals: 'Socles Liberty',
    evolve_pedestals: 'Socles Evolve',
    other_pedestals: 'Autres socles',
    e10_pedestals: 'E10',
    p20_pedestals: 'P20',
    noAdPanel_pedestals: ' Liberty/Evolve sans panneau pub',
    manned_checkout_number: 'Caisses de sortie avec caissiers',
    self_checkout_number: 'Caisse de sortie automatisées',
    no_of_coupon_zones: 'Panneau Zonne de bons',
    notes: 'Notes',
    store_items: 'Articles',
    store_manager: 'Gestionnaire',
    class_of_trade: 'Catégorie',
    report: 'Signaler un fait',
    tasks: 'Tâches',
    productLines: 'Gamme de produits',
    picklist: 'Liste de sélection',
    recommendations: 'Recommandations',
    visiting: 'En visite',
    contact_name: 'Gestionnaires',
    store_number: 'Numéro de magasin',
    chain_name: 'Enseigne',
    chain_short_name: 'Nom abrégé de la chaîne',
    end_survey: 'Terminer le questionnaire',
    update_survey: 'Actualiser le questionnaire',
  },
  taskProfile: {
    noTask:
      "La tâche n'a pas pu être chargée. Veuillez redémarrer FHS Next Gen et si le problème persiste, contactez votre responsable.",
    ad_qty_type: 'Qté et type de visuel',
    art_description: 'Description du visuel',
    artwork_id: 'ID Visuel',
    artwork: 'Visuel',
    attachment: 'Pièce(s) jointe(s)',
    cancelTask: 'Supprimer les tâches',
    checkInToStart: 'Signer le registre du magasin avant de commencer cette tâche',
    completed: 'Terminé',
    desc_art_id: 'Description/Visuel ID',
    endTask: 'Conclure la tâche',
    errorSavingRecap:
      "Une erreur s'est produite lors de la tentative de fin de la tâche. Veuillez réessayer.",
    est_task_duration: 'Durée approx. de la tâche',
    includeRecap: 'Inclure le récap',
    initial_image_rai: 'Première image RAI',
    instructions: 'Consignes',
    inventory_item: "Article d'inventaire",
    job_description: 'Description du projet',
    job_id: 'ID du projet',
    kit: 'Trousse',
    limited_quantity_buy: "Qté d'achat limitée",
    maintain_image_rai: "Maintenir l'image RAI",
    open: 'Ouvert',
    order_sale_id: 'ID commande',
    order_sales_id: 'Ordre ventes ID',
    paused: 'En suspens',
    pauseTask: 'Tâche en suspens',
    placement_section: 'Section de placement',
    prev_item_installed: 'Aricle précédent posé',
    previous_ad_qty: 'Qté précédente des pubs',
    previous_ad_quantity: 'Qté précédente des pubs',
    previous_execution_timestamp_tz: "Date d'exécution précédente",
    previous_inventory_item: "Article de l'inventaire précédent ",
    previous_placement_id: 'Placement précédent',
    previous_placement: 'Placement précédent',
    previous_rai_code: 'RAI précédente',
    previous_rai: 'RAI précédent',
    product_line: 'Gamme de produits',
    quantity_installed: 'Qté installée',
    remove_image_rai: "Supprimer l'image RAI",
    resumeTask: 'Reprendre la tâche ',
    running: 'En cours',
    showRecap: 'Montrer le récap',
    space_id: 'ID espace',
    special_instructions: 'Consignes spéciales',
    startTask: 'Commencer la tâche',
    submitted: 'Soumis',
    supplies_sent_to: 'Fournitures envoyées à',
    task_status: 'Statut',
    task_type: 'Type de tâche',
    task: 'Tâche',
    test_indicator: 'MPT',
    value: 'Valeur du bon-rabais',
    wave: 'Vague',
  },
  tables: {
    tasks: 'Tâches',
    merchPlanner: 'Planificateur Mise en marché',
    stores: 'Tous les magasins',
    workView: 'Visualiser le travail',
    balance: 'Balance',
    allItems: 'Tous les articles',
    orders: 'Commandes',
  },
  messaging: {
    offline:
      'Vos messages hors connexion seront transmis/reçus lorsque votre appareil sera connecté.',
    noMessagesInbox: 'Votre boîte de réception est vide.',
    noMessagesOutbox: "Votre boîte d'envoi est vide.",
    sentMessagesRemoved:
      'Les messages envoyés seront automatiquement supprimés au bout de 30 jours.',
    inbox: 'Boîte de réception',
    outbox: "Boîte d'envoi",
    sent: 'Envoyer',
  },
}
